export default {
  NOT_STARTED: 'notStarted',
  REGISTERED: 'registered',
  NO_EXTERNAL_ACCOUNT_FOUND: 'noExternalAccountFound',
  COMPLETE: 'complete',
  TERM_COMPLETE: 'termComplete',
  TERM_EXPIRED: 'termExpired',
  ON_HOLD: 'onHold',
  REJECTED: 'rejected',
};
